<ecmo-page [pageTitle]="'legals.cookies.title' | translate" [greyBackground]='true'>
  <ecmo-cookies-only [withButton]='true'></ecmo-cookies-only>

  <ecmo-footer [absolute]='false'></ecmo-footer>
</ecmo-page>
